import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import {MatIcon} from '@angular/material/icon';
import {MakeAPaymentValue} from '@store/account/account.types';
import {FormatPipeModule} from '../../../shared/pipes/format-pipe.module';
import {MatButton} from '@angular/material/button';

export interface PaymentConfirmationDialogData {
  value: MakeAPaymentValue;
}

@Component({
  selector: 'rn-payment-confirmation',
  template: `
    <mat-dialog-content class="payment-confirmation-wrapper">
      <div class="header">
        <div class="dialog-close-row flex-row flex-center-space-between">
          <div class="mat-headline-4">Payment Confirmation</div>
          <mat-icon class="close-icon pointer" (click)="close()">close</mat-icon>
        </div>
      </div>
      <div class="mat-headline-6">Thank you for your payment!</div>
      <div class="flex-col">
        <div class="mat-subtitle-1">Amount: {{ value.amount | format: 'CURRENCY' }}</div>
        <div>**** **** **** {{ value.last4 }}</div>
        <div>{{ now | format: 'DATE_ONLY' }}</div>
        <div>{{ value.transactionId }}</div>
      </div>
      <div class="button-row flex-row flex-center-end">
        <button mat-raised-button color="primary" class="save-button-group" (click)="close()">
          <span>Close</span>
        </button>
      </div>
    </mat-dialog-content>
  `,
  styles: `
    .payment-confirmation-wrapper {
      width: min(25rem, 80vw);
    }

    .mat-headline-4 {
      margin-bottom: 2rem;
    }

    .mat-headline-6 {
      margin-bottom: 0.75rem;
    }

    .mat-subtitle-1 {
      margin-bottom: 0;
    }

    .close-icon {
      margin-bottom: 16px;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogContent, MatIcon, FormatPipeModule, MatButton]
})
export class PaymentConfirmationDialog {
  public readonly dialogData: PaymentConfirmationDialogData = inject(MAT_DIALOG_DATA);
  public readonly value: MakeAPaymentValue = this.dialogData.value;
  public readonly now = new Date();
  private readonly dialogRef: MatDialogRef<PaymentConfirmationDialog> = inject(MatDialogRef);

  close(): void {
    this.dialogRef.close(false);
  }
}
